import React, { ComponentProps } from 'react';
import { Label } from 'src/components/atomsLegacy';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import styled from 'styled-components';
import { StyledInputError } from './DatePicker.styles';

export type DatePickerProps = ComponentProps<typeof Input> & {
  label?: string;
  width?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  errorMessage?: string;
};

export const DatePicker = ({
  label,
  width,
  error,
  errorMessage,
  ...props
}: DatePickerProps) => {
  const theme = useTheme();
  return (
    <Container marginTop={Boolean(label)} width={width}>
      {label && <Label htmlFor={props.id}>{label}</Label>}
      <Input type="date" marginTop={Boolean(label)} {...props} />
      {error ? (
        <StyledInputError>
          <StyledIcon
            className={'uil uil-exclamation-circle'}
            color={
              theme.isVaultVariant
                ? theme.newPalette.red.R300
                : theme.atlas.semantic.color.action.destructive.default
            }
            size="12px"
          ></StyledIcon>
          &nbsp;
          {errorMessage ?? 'Invalid date'}
        </StyledInputError>
      ) : null}
    </Container>
  );
};

const Container = styled.div<{ marginTop?: boolean; width?: string }>`
  margin-top: ${(props) => (props.marginTop ? '16px' : '0')};
  width: ${(props) => props.width ?? '50%'};
`;

const Input = styled.input<{ marginTop?: boolean; error?: boolean }>`
  margin-top: ${(props) => (props.marginTop ? '16px' : '0')};
  height: 32px;
  width: 100%;
  border: solid 1px
    ${(props) =>
      props.error
        ? props.theme.isVaultVariant
          ? props.theme.newPalette.red.R300
          : props.theme.atlas.semantic.color.action.destructive.default
        : props.theme.isVaultVariant
          ? props.theme.newPalette.neutral.N400
          : props.theme.atlas.semantic.color.outline.default};
  border-radius: 4px;
  padding: 5px 8px;
  cursor: pointer;
`;
